import { FC } from 'react';
import { Box, Paper } from '@mui/material';
import GuardianConversationList from './components/guardianConversationList.view';
import GuardianChatWindow from './components/guardianChatWindow.view';

const GuardianMessagingView: FC = () => {
  return (
    <Box
      sx={{
        height: 'calc(100vh - 200px)',
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        bgcolor: 'grey.100',
        borderRadius: { xs: 0, sm: 1 },
        overflow: 'hidden',
        px: { xs: 0, sm: 1 },
        py: { xs: 1, sm: 0 },
      }}
      data-testid="guardian-messaging-view"
    >
      {/* Left Sidebar - Conversation List */}
      <Paper
        elevation={0}
        sx={{
          width: { xs: '100%', md: '35%' },
          minWidth: { xs: 'auto', md: 300 },
          maxWidth: { xs: '100%', md: 400 },
          height: { xs: '40%', md: '100%' },
          display: 'flex',
          flexDirection: 'column',
          borderRight: { xs: 0, md: 1 },
          borderBottom: { xs: 1, md: 0 },
          borderColor: 'divider',
          borderRadius: { xs: 0, sm: 1 },
        }}
        data-testid="guardian-messaging-conversation-list-container"
      >
        <GuardianConversationList />
      </Paper>

      {/* Right Panel - Chat Window */}
      <Box 
        sx={{ 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column',
          height: { xs: '60%', md: '100%' },
        }}
        data-testid="guardian-messaging-chat-window-container"
      >
        <GuardianChatWindow />
      </Box>
    </Box>
  );
};

export default GuardianMessagingView;
